var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.ready)?_c('router-view',{attrs:{"moduleName":_vm.tplName,"actCode":_vm.code},on:{"reportEvent":_vm.handleReport}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }